/**
 * Reference: https://ckeditor.com/docs/ckeditor4/latest/guide/dev_react_v2.html
 */

import { CKEditor } from 'ckeditor4-react';
// import UploadAdapter from './UploadClass';
import { memo, useEffect, useState } from 'react';
import { storageKeys } from 'utilities/constants';
import AppStorage from 'utilities/storage.service';

// CKEditor.editorUrl = 'http://custom-editor-config.s3-website.ap-south-1.amazonaws.com/ckeditor.js';

const EDITOR_HEIGHT = 320;
const styleName = `edPodia_sty${Math.random()}`;
function Editor({ heading, data: { value, onChange } = {}, config = {}, editorConfig = {} }) {
  return (
    <div className="Editor_App">
      {heading && <label>{heading}</label>}
      <CKEditor
        initData={value}
        onChange={(e) => onChange(e.editor.getData())}
        onInstanceReady={({ editor }) => {
          editor.on('fileUploadRequest', function (evt) {
            const fileLoader = evt.data.fileLoader;
            const formData = new FormData();

            const token = AppStorage.getItem(storageKeys.APP_TOKEN);

            fileLoader.xhr.open('POST', fileLoader.uploadUrl, true);
            formData.append('file', fileLoader.file, fileLoader.fileName);
            fileLoader.xhr.setRequestHeader('X-access-control', 'public');
            fileLoader.xhr.setRequestHeader('X-reference-key', 'ES_LOGO');
            fileLoader.xhr.setRequestHeader('Authorization', `Bearer ${token}`);
            fileLoader.xhr.send(formData);

            // Prevented the default behavior.
            evt.stop();
          });
        }}
        onBeforeLoad={(CKEDITOR, editor) => {
          // CKEDITOR.stylesSet.add(styleName, [
          //   // Image styles.
          //   {
          //     name: 'Inline Image',
          //     element: 'div',
          //     attributes: { class: '__arr__img__inline' },
          //   },
          //   // Edpodia Specific.
          //   {
          //     name: 'Sub heading lesson',
          //     element: 'h4',
          //     attributes: { class: '__arr__lesson_heading' },
          //   },
          // ]);
        }}
        // onBeforeLoad={(CKEDITOR, editor) => {
        //   //workable but not used
        //   CKEDITOR.on('dialogDefinition', (ev) => {
        //     var dialogName = ev.data.name;
        //     var dialogDefinition = ev.data.definition;
        //    console.log('🚀 ~ file: Editor.js ~ line 41 ~ Editor ~ editor', editor);
        //     // if (dialogName == 'image2') {
        //     //   var infoTab = dialogDefinition.getContents('info');
        //     //   infoTab.add({
        //     //     type: 'text',
        //     //     width: '50px',
        //     //     label: 'Border Thickness',
        //     //     id: 'borderField',
        //     //     default: '0',
        //     //     validate: function () {
        //     //       if (/[^\d]/.test(this.getValue()))
        //     //         return alert('Invalid value. Should be in number');
        //     //     },
        //     //   });
        //     //   var dialog = dialogDefinition.dialog;
        //     //   dialog.on('ok', function () {
        //     //     var image = widget.parts.image;

        //     //     var borderField = this.getContentElement('info', 'borderField');

        //     //     var newBorderWidth = borderField.getValue() + 'px';

        //     //     image.setStyle('border-style', 'solid');
        //     //     image.setStyle('border-width', newBorderWidth);
        //     //   });
        //     // }
        //   });
        // //https://stackoverflow.com/questions/20718260/image2-plugin-for-ckeditor-4-3-how-to-remove-url-and-add-border-management-to-t
        // }}
        config={{
          versionCheck: false,
          removePlugins: 'elementspath',
          // extraPlugins: 'eqneditor,font,mathjax,pastecode,stylesheetparser,editorplaceholder',
          extraPlugins: 'uploadimage,stylesheetparser,editorplaceholder,font, image2',
          // mathJaxLib:
          //   'https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.4/MathJax.js?config=TeX-AMS_HTML',
          height: EDITOR_HEIGHT,
          editorplaceholder: 'Start typing here...',
          baseFloatZIndex: 10000000,
          filebrowserImageUploadUrl:
            process.env.REACT_APP_API_URL +
            '/v1/admin/upload?source=editor&public=true&CKEditorJSON=true',
          allowedContent: true,
          pasteFromWordNumberedHeadingToList: true,
          pasteFromWordRemoveStyles: false,
          toolbar,
          toolbarGroups,
          ...config,
          font_names: 'Inter',
          font_defaultLabel: 'Inter',
          contentsCss:
            'http://custom-editor-config.s3-website.ap-south-1.amazonaws.com/contents.css',
          stylesSet: [
            {
              name: 'Inline Image',
              element: 'div',
              attributes: { class: '__arr__img__inline' },
            },
            // Edpodia Specific.
            {
              name: 'Heading',
              element: 'h4',
              attributes: { class: '__arr__lesson_heading ---edp--title--editor--heading-1' },
            },
            {
              name: 'Sub heading',
              element: 'h4',
              attributes: { class: '__arr__lesson_heading__2 ---edp--title--editor--heading-2' },
            },
            {
              name: 'List Bold Container',
              element: ['ul'],
              attributes: {
                class:
                  '__arr__lesson_heading__bulletin_bold ---edp--bullet-title--editor--bold-container',
              },
            },
            {
              name: 'List Regular Container',
              element: ['ul'],
              attributes: {
                class:
                  '__arr__lesson_heading__bulletin_bold ---edp--bullet-title--editor--regular-container',
              },
            },
            {
              name: 'Bullet BOLD',
              element: 'li',
              attributes: {
                class:
                  '__arr__lesson_heading__bulletin_bold ---edp--bullet-title--editor--bold-heading',
              },
            },
            {
              name: 'Sub Bullet BOLD',
              element: 'li',
              attributes: {
                class:
                  '__arr__lesson_heading__bulletin_semi ---edp--bullet-title--editor--semi-bold-heading',
              },
            },
            {
              name: 'Tertiary Bullet BOLD',
              element: 'li',
              attributes: {
                class:
                  '__arr__lesson_heading__bulletin_semi ---edp--bullet-title--editor--tertiary-bold-heading',
              },
            },
            {
              name: 'List Content',
              element: 'p',
              attributes: {
                class:
                  '__arr__lesson_heading__bulletin_semi ---edp--bullet-title--editor--list-content',
              },
            },
            {
              name: 'Regular heading list contents',
              element: 'div',
              attributes: {
                class:
                  '__arr__lesson_heading__bulletin_r ---edp--bullet-lists-w-regular--editor--contents',
              },
            },
            {
              name: 'Explanation for Problem box',
              element: 'div',
              attributes: { class: '__arr__explanation_problem_specific' },
            },
            {
              name: 'Tables',
              element: 'table',
              attributes: {
                class: '__table __arr__edp__table__ ---edp--tables',
              },
            },
          ],
          image2_alignClasses: ['editor-image-left', 'editor-image-center', 'editor-image-right'],
        }}
        {
          ...editorConfig
          // 'default': {
          //     'versionCheck': false
          // },
          // 'versionCheck': false
        }
      />
    </div>
  );
}

Editor.defaultProps = {
  data: {
    value: '',
    onChange: () => console.log('No change event attached'),
  },
};

const toolbarGroups = [
  {
    name: 'document',
    groups: ['mode', 'document', 'doctools'],
  },
  {
    name: 'clipboard',
    groups: ['clipboard', 'undo'],
  },
  {
    name: 'editing',
    groups: ['find', 'selection', 'spellchecker', 'editing'],
  },
  {
    name: 'forms',
    groups: ['forms'],
  },
  '/',
  {
    name: 'paragraph',
    groups: ['list', 'indent', 'blocks', 'align', 'bidi', 'paragraph'],
  },
  {
    name: 'links',
    groups: ['links'],
  },
  {
    name: 'insert',
    groups: ['insert'],
  },
  '/',
  {
    name: 'styles',
    groups: ['styles'],
  },
  {
    name: 'basicstyles',
    groups: ['basicstyles', 'cleanup'],
  },
  {
    name: 'colors',
    groups: ['colors'],
  },
  {
    name: 'tools',
    groups: ['tools'],
  },
  {
    name: 'others',
    groups: ['others'],
  },
  {
    name: 'about',
    groups: ['about'],
  },
];

// const toolbar = [{ items: ['Bold', 'Italic', 'Image'] }];
const toolbar = [
  {
    name: 'clipboard',
    groups: ['clipboard', 'undo'],
    items: ['Cut', 'Copy', 'Paste', 'PasteText', 'PasteFromWord', '-', 'Undo', 'Redo'],
  },
  //{ name: 'editing', groups: ['find', 'selection', 'spellchecker'], items: ['Scayt'] },
  { name: 'links', items: ['Link', 'Unlink'] },
  { name: 'insert', items: ['Image', 'Table', 'HorizontalRule', 'SpecialChar'] },
  //{ name: 'tools', items: ['Maximize'] },
  //{ name: 'document', groups: ['mode', 'document', 'doctools'], items: ['Source'] },
  //{ name: 'others', items: ['-'] },
  '/',
  {
    name: 'basicstyles',
    groups: ['basicstyles', 'cleanup'],
    items: ['Bold', 'Italic', 'Strike', '-', 'RemoveFormat'],
  },
  {
    name: 'paragraph',
    groups: ['list', 'indent', 'blocks', 'align', 'bidi'],
    items: ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote'],
  },
  { name: 'styles', items: ['Styles', 'Format', 'Font'] },
  { name: 'about', items: ['About'] },
];

function EditorShimmer(props) {
  const [showEditor, setShowEditor] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setShowEditor(true);
    }, 2000);
  }, []);

  if (!showEditor) return <div style={{ minHeight: EDITOR_HEIGHT }}>Loading...</div>;

  return <Editor {...props} />;
}

export default memo(EditorShimmer);
